exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ma__content h2.title {\n  font-weight: 600;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /data/public_html/app/themes/aad-matthewalgie/node_modules/css-loader!/data/public_html/app/themes/aad-matthewalgie/node_modules/vue-loader/lib/loaders/stylePostLoader.js!/data/public_html/app/themes/aad-matthewalgie/node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sassOptions":{"indentedSyntax":true}}!/data/public_html/app/themes/aad-matthewalgie/node_modules/vue-loader/lib?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!/data/public_html/app/themes/aad-matthewalgie/node_modules/import-glob!/data/public_html/app/themes/aad-matthewalgie/node_modules/import-glob!./scripts/vue/components/Utilities/Modal.vue?vue&type=style&index=0&id=24ea0f7a&lang=sass&
// module id = 138
// module chunks = 3